<script lang="ts">
  import { Accordion, AccordionItem, Skeleton } from "flowbite-svelte";
  import BridgeHeader from "./BridgeHeader.svelte";
  import BridgeFooter from "./BridgeFooter.svelte";
  import Spinner from "../../components/Essentials/loading/Spinner.svelte";

  export let loading = true;
</script>

<div class="py-3 px-7 md:px-1 flex flex-col gap-4 h-full">
  <BridgeHeader />
  <!-- Dieser Container ist der scrollbare Content-Bereich -->
  {#if loading}
    <div class="w-full flex items-center justify-center">
      <Spinner classes="w-6 h-6 min-w-6 min-h-6 !border-t-#505A67" />
      <span class="text-lg">Bitte warten Sie einen Moment. Der Text wird gerade vereinfacht.</span>
    </div>
  {:else}
    <slot />
    <BridgeFooter />
  {/if}
</div>

<style>
  :global(body, html) {
    background-color: transparent !important;
    outline: none;
  }
</style>
